const View = require('./SyncerPage').default
const container = require('./container')


module.exports = container(View)
